import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from 'app/app.constants';
import { MetricsProviderWithImplicitMappingsDataService } from '../services/metrics-provider-with-implicit-mappings-data.service';

@Injectable({
  providedIn: 'root'
})
export class LinkedInDataService extends MetricsProviderWithImplicitMappingsDataService {
  constructor(
    private readonly configuration: Configuration,
    public readonly client: HttpClient
  ) {
    super(client, configuration.linkedin_service_url);
  }
}
